import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

// All supported languages
export const supportedLanguages = [
  'en', 'zh', 'es', 'hi', 'ar', 'pt', 'bn', 'ru', 'ja', 'pa',
  'de', 'jv', 'ko', 'fr', 'te', 'mr', 'tr', 'ta', 'vi', 'ur',
  'it', 'th', 'gu', 'pl', 'uk', 'ml', 'kn', 'or', 'my', 'fa',
  'nl', 'su', 'ro', 'ha', 'sw', 'am', 'yo', 'ig', 'uz', 'ms',
  'sd', 'ne', 'si', 'km', 'tk', 'cs', 'el', 'hu', 'sv', 'be',
  'az', 'he', 'fi', 'da', 'no', 'sk', 'bg', 'hr', 'sr', 'lt',
  'lv', 'sl', 'et', 'mk', 'sq', 'ka', 'hy', 'mn', 'kk', 'lo',
  'ps', 'af', 'id', 'tl', 'cy'
];

// RTL languages
export const rtlLanguages = ['ar', 'he', 'fa', 'ur', 'sd', 'ps'];

i18n
  .use(resourcesToBackend((language: string) => import(`../locales/${language}.json`)))
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    debug: import.meta.env.DEV,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: true,
      // re-render components when the CMS layer adds/overrides resource bundles
      bindI18nStore: 'added',
    }
  });

// Update document direction when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.setAttribute('dir', rtlLanguages.includes(lng) ? 'rtl' : 'ltr');
});

export default i18n;
